import { Orbit } from 'loading-dev';
import { CircleCheckIcon, InfoIcon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '../app/theme.tsx';

// Sem `next-themes` (WEB-100): o tema vem do provider próprio do painel e os tokens saem
// de `styles/tokens.css`.
const Toaster = ({ ...props }: ToasterProps) => {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        // Ouro do pião (`--teal`, ver `styles/tokens.css`). Tamanho por `size`: o CSS do
        // loading-dev fica fora de @layer e ganharia de um `size-4`.
        loading: <Orbit size={16} color="var(--teal)" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
